module.exports = __webpack_public_path__ + "img/mp_logo_w_min.48178d9f.png";